import { Title } from 'ui';
// eslint-disable-next-line @typescript-eslint/no-restricted-imports -- TODO: fix according to result of #67489
import { useLoginMutation, useLoginToNodeMutation } from 'features/users/queries';
import LoginForm from '../components/LoginForm';
import { useAuthenticateMutation } from '../queries';
import { useUseHandleLoginError } from './hooks';

type P<T> = {
  onExpiredPassword: (email: string) => Promise<void>;
  onNavigateToCheckCode: ({ tokenToGetCode, tokenToLogin }: { tokenToGetCode?: string; tokenToLogin?: string }) => void;
  onNavigateToForgotPassword: (email?: string) => Promise<void>;
  onNavigateToPrimaryLogin: () => Promise<void>;
  onSuccessLogin: () => Promise<void>;
  publicCommunityId?: string;
  state?: T;
};

const PasswordLogin = <T,>({
  onExpiredPassword,
  onNavigateToCheckCode,
  onNavigateToForgotPassword,
  onNavigateToPrimaryLogin,
  onSuccessLogin,
  publicCommunityId,
  state,
}: P<T>) => {
  const { mutateAsync: loginAsync } = useLoginMutation();
  const { mutateAsync: nodeLoginAsync } = useLoginToNodeMutation();

  const { isPending: isLoading, mutate: authenticate } = useAuthenticateMutation();

  const {
    contextHolder,
    handleError: handleLoginError,
    isMfaLoginLoading,
  } = useUseHandleLoginError({ onNavigateToCheckCode, onSuccessLogin });

  const onSubmit = ({ email, password }: { email: string; password: string }) => {
    authenticate(
      {
        async nodeLogin() {
          return nodeLoginAsync({
            email,
            password,
            strategy: 'password',
          });
        },
        async railsLogin() {
          return loginAsync({ email, password, publicCommunityId });
        },
      },

      {
        async onError(error) {
          await handleLoginError({ email, error, onExpiredPassword, onNavigateToForgotPassword });
        },
        async onSuccess() {
          await onSuccessLogin();
        },
      },
    );
  };

  return (
    <>
      <Title level={1} marginBottom>
        Use password to log in
      </Title>
      <div className="onboarding-password-login__form-wraper">
        <LoginForm<T>
          loading={isLoading || isMfaLoginLoading}
          onNavigateToPrimaryLogin={onNavigateToPrimaryLogin}
          onSubmit={onSubmit}
          state={state}
        />
      </div>
      {contextHolder}
    </>
  );
};

export default PasswordLogin;
